import{getAugmentedNamespace as l}from"./_commonjsHelpers.js";import*as o from"../node_modules/.pnpm/rollup-plugin-node-polyfills@0.2.1/node_modules/rollup-plugin-node-polyfills/polyfills/tty.js";var p=l(o);export{p as default};
